<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
{{ "bikeshop.shop_setup.card_headers.service_deposits" | translate }}
</span>
    </div>
  </div>
  <div>
    <div *ngIf="loading || busy"
         style="margin-top: 16px;margin-bottom: 16px;display: flex;justify-content: center;">
      <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
      </p-progressSpinner>
    </div>
    <div *ngIf="DepositConfigForm">
      <div class="row">
        <div class="col-md-12">
          <div class="content">
            <form [formGroup]="DepositConfigForm" (ngSubmit)="saveConfig(DepositConfigForm.value)">


              <div>
                <div class="row margin-top-16">
                  <div class="col-md-12 section-header">
                    {{ 'bikeshop.rentals.configuration.payment' | translate }}
                  </div>
                </div>
                <div class="row margin-top-8">
                  <div class="col-md-3 label">
                    {{ "bikeshop.rentals.configuration.take_payment_during_online_booking" | translate }}
                    :
                  </div>
                  <div class="col-md-9">
                    <p-inputSwitch formControlName="paymentOnCheckout"
                                   [disabled]="!(isStipeIntegrated && isPOSPaymentsSupported)"></p-inputSwitch>
                  </div>
                </div>
                <div class="row margin-top-8" *ngIf="DepositConfigForm.value.paymentOnCheckout">
                  <div class="col-md-3 label"
                       [ngClass]="{'red': !DepositConfigForm.value.fullPaymentOrDeposit}">
                    {{ "bikeshop.rentals.configuration.payment_full_or_deposit" | translate }}:
                  </div>
                  <div class="col-md-9 radio-container">
                    <p-radioButton name="fullPaymentOrDeposit" value="FULL"
                                   formControlName="fullPaymentOrDeposit"
                                   label="{{ 'bikeshop.rentals.configuration.full_payment' | translate }}"
                                   [disabled]="!DepositConfigForm.value.paymentOnCheckout"></p-radioButton>
                    <p-radioButton name="fullPaymentOrDeposit" value="DEPOSIT"
                                   formControlName="fullPaymentOrDeposit"
                                   label="{{ 'bikeshop.rentals.configuration.deposit' | translate }}"
                                   [disabled]="!DepositConfigForm.value.paymentOnCheckout"></p-radioButton>
                  </div>
                </div>
                <div class="row margin-top-8"
                     *ngIf="DepositConfigForm.value.paymentOnCheckout && DepositConfigForm.value.fullPaymentOrDeposit === 'DEPOSIT'">
                  <div class="col-md-3 label"
                       [ngClass]="{'red': !DepositConfigForm.value.depositPercentOrFixed}">
                    {{ "bikeshop.rentals.configuration.deposit_percent_or_fixed" | translate }}:
                  </div>
                  <div class="col-md-9 radio-container">
                    <p-radioButton name="depositPercentOrFixed" value="PERCENT"
                                   formControlName="depositPercentOrFixed"
                                   label="{{ 'bikeshop.rentals.configuration.percent' | translate }}"></p-radioButton>
                    <p-radioButton name="depositPercentOrFixed" value="FIXED"
                                   formControlName="depositPercentOrFixed"
                                   label="{{ 'bikeshop.rentals.configuration.fixed' | translate }}"></p-radioButton>
                  </div>
                </div>
                <div class="row margin-top-8"
                     *ngIf="DepositConfigForm.value.paymentOnCheckout && DepositConfigForm.value.fullPaymentOrDeposit === 'DEPOSIT' && DepositConfigForm.value.depositPercentOrFixed === 'PERCENT'">
                  <div class="col-md-3 label"
                       [ngClass]="{'red': !DepositConfigForm.value.depositValue}">
                    {{ "bikeshop.rentals.configuration.deposit_percent_amount" | translate }}:
                  </div>
                  <div class="col-md-2 label">
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon"><i>%</i></span>
                      <input type="number" pInputText formControlName="depositValue"/>
                    </div>
                  </div>
                </div>
                <div class="row margin-top-8"
                     *ngIf="DepositConfigForm.value.paymentOnCheckout && DepositConfigForm.value.fullPaymentOrDeposit === 'DEPOSIT' && DepositConfigForm.value.depositPercentOrFixed === 'FIXED'">
                  <div class="col-md-3 label"
                       [ngClass]="{'red': !DepositConfigForm.value.depositValue}">
                    {{ "bikeshop.rentals.configuration.deposit_fixed_amount" | translate }}:
                  </div>
                  <div class="col-md-2 label">
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon"><i>{{partner.CurrencySymbol}}</i></span>
                      <input type="number" pInputText formControlName="depositValue"/>
                    </div>
                  </div>
                </div>

                <div class="row margin-top-8"
                     *ngIf="DepositConfigForm.value.paymentOnCheckout && DepositConfigForm.value.fullPaymentOrDeposit === 'DEPOSIT' && DepositConfigForm.value.depositPercentOrFixed === 'PERCENT'">
                  <div class="col-md-3 label">
                    {{ "bikeshop.rentals.configuration.minimum_value" | translate }}:
                  </div>
                  <div class="col-md-2 label">
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon"><i>{{partner.CurrencySymbol}}</i></span>
                      <input type="number" pInputText formControlName="minimumValue"/>
                    </div>
                  </div>
                </div>

                <div class="row margin-top-8" *ngIf="DepositConfigForm.value.paymentOnCheckout">
                  <div class="col-md-3 label">
                    {{ "bikeshop.rentals.configuration.apply_all_service_types" | translate }}:
                  </div>
                  <div class="col-md-9">
                    <p-inputSwitch formControlName="allServiceTypes"></p-inputSwitch>
                  </div>
                </div>


                <div class="row margin-top-16"
                     *ngIf="DepositConfigForm.value.paymentOnCheckout && !DepositConfigForm.value.allServiceTypes">
                  <div class="col-md-3 label">
                    {{ "bikeshop.rentals.configuration.select_service_types" | translate }}:
                  </div>
                  <div class="col-md-9 value">
                    <p-multiSelect #serviceTypeDropDown [options]="serviceTypes"
                                   formControlName="linkedServices"
                                   [filter]="true" [showHeader]="true" scrollHeight="380px"
                                   [showToggleAll]="true"
                                   [showHeader]="true" [resetFilterOnHide]="true" autofocus="true"
                                   [showToggleAll]="false">
                    </p-multiSelect>
                  </div>
                </div>

                <div class="row margin-top-16" *ngIf="DepositConfigForm.value.paymentOnCheckout">
                  <div class="col-md-3 label">
                    {{ "bikeshop.rentals.configuration.payment_terms" | translate }}:
                  </div>
                  <div class="col-md-9">
                    <div>
                      <quill-editor formControlName="paymentTermsAndConditions"
                                    [style]="{'height':'280px', 'width':'100%'}"
                                    [modules]="modules" format="html">
                      </quill-editor>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row margin-top-16">
                <div class="col-md-9"></div>
                <div class="col-md-3">
                  <button pButton type="submit" class="p-button-raised full-width" label="{{
                    'bikeshop.rentals.configuration.update_configuration' | translate
                  }}" [disabled]="!DepositConfigForm.valid || busy"></button>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast position="bottom-right" key="service-deposit-config"></p-toast>
